"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAddress = void 0;
const jsontokens_1 = require("jsontokens");
const provider_1 = require("../provider");
const getAddress = async (options) => {
    const provider = await (0, provider_1.getProviderOrThrow)(options.getProvider);
    const { purposes } = options.payload;
    if (!purposes) {
        throw new Error('Address purposes are required');
    }
    try {
        const request = (0, jsontokens_1.createUnsecuredToken)(options.payload);
        const response = await provider.connect(request);
        options.onFinish?.(response);
    }
    catch (error) {
        console.error('[Connect] Error during address request', error);
        options.onCancel?.();
    }
};
exports.getAddress = getAddress;
__exportStar(require("./types"), exports);
